<template>
  <div class="horizontal-scroller">
    <button
      v-if="canScrollLeft"
      type="button"
      class="horizontal-scroller__scroll-arrow horizontal-scroller__scroll-arrow--left"
      @click="scroll('left')"
    >
      <UseSvg
        class="horizontal-scroller__scroll-arrow-icon"
        :class="{
          'horizontal-scroller__scroll-arrow-icon--standard-artwork': isStandardArtwork
        }"
        icon="arrow-left"
      />
    </button>
    <div
      ref="scroller"
      class="horizontal-scroller__scroller"
      v-bind="$attrs"
      @scroll="checkScrollState"
    >
      <slot></slot>
    </div>
    <button
      v-if="canScrollRight"
      type="button"
      class="horizontal-scroller__scroll-arrow horizontal-scroller__scroll-arrow--right"
      @click="scroll('right')"
    >
      <UseSvg
        class="horizontal-scroller__scroll-arrow-icon"
        :class="{
          'horizontal-scroller__scroll-arrow-icon--standard-artwork': isStandardArtwork
        }"
        icon="arrow-right"
      />
    </button>
  </div>
</template>

<script>
import { mapState } from "pinia";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";
import { nextTick } from "vue";
import { useDtfStore } from "../store";

export default {
  name: "HorizontalScroller",
  components: {
    UseSvg
  },
  data() {
    return {
      scrollState: {
        canScrollLeft: false,
        canScrollRight: false
      }
    };
  },
  computed: {
    ...mapState(useDtfStore, ["isStandardArtwork"]),
    scroller() {
      return this.$refs.scroller;
    },
    canScrollLeft() {
      return this.scrollState.canScrollLeft;
    },
    canScrollRight() {
      return this.scrollState.canScrollRight;
    }
  },
  mounted() {
    nextTick(() => {
      this.checkScrollState();
    });
    window.addEventListener("resize", this.checkScrollState);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScrollState);
  },
  methods: {
    checkScrollState() {
      if (!this.scroller) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.scroller;
      this.scrollState = {
        canScrollLeft: scrollLeft - 30 > 0,
        canScrollRight: scrollLeft + clientWidth + 30 < scrollWidth
      };
    },
    scroll(direction) {
      if (!this.scroller) return;
      const multiplier = direction === "left" ? -1 : 1;
      this.scroller.scrollBy({
        left: multiplier * this.scroller.clientWidth,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "frontend/init/jiffy/settings.scss";

.horizontal-scroller {
  $this: &;

  display: flex;
  align-items: center;
  position: relative;

  &:hover {
    #{$this}__scroll-arrow {
      opacity: 1;
    }
  }

  &__scroller {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    scroll-behavior: smooth;
    flex: 1;
    padding: 4px;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__scroll-arrow {
    position: absolute;
    background: $white;
    border: none;
    width: 32px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    padding: 0;
    opacity: 0;

    &--left {
      left: 0;
      background: linear-gradient(90deg, rgba($white, 1) 0%, rgba($white, 0.25) 100%);
    }

    &--right {
      right: 0;
      background: linear-gradient(90deg, rgba($white, 0.25) 0%, rgba($white, 1) 100%);
    }
  }

  &__scroll-arrow-icon {
    width: 16px;
    height: 16px;
    color: $primary-600;

    &--standard-artwork {
      color: $primary;
    }
  }
}
</style>
